import { CountryInfo } from "@/api/SolarCloudApi";
import H1 from "./ui/H1";
import P from "./ui/P";
import { RegisterContactDetailsForm } from "@/forms/RegisterContactDetailsForm";

type UnavailableInCountryProps = {
  country?: CountryInfo;
  countries?: CountryInfo[];
};
export default function UnavailableInCountry({
  country,
  countries,
}: UnavailableInCountryProps) {
  return (
    <div className="py-20 space-y-6 max-w-xl mx-auto">
      <H1 className="">Buy panels unavailable in your country</H1>

      <div>
        <P className="text-center">
          This service is not currently available in {country?.name}.
        </P>
        <P className="text-center">
          We currently support the following countries:
        </P>
        <ul className="list-disc list-inside space-y-1 ml-4 mt-2 flex flex-col items-center">
          {countries
            ?.filter((c) => c.code !== country?.code)
            .map((c) => (
              <li key={c.code} className="w-44">
                {c.name}
              </li>
            ))}
        </ul>
      </div>
      <RegisterContactDetailsForm />
    </div>
  );
}
